import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={40}
            height={41}
            viewBox="0 0 40 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <rect y={0.578125} width={40} height={40} rx={20} fill={theme["#B4E3E1"]} />
            <path
                d="M19.422 13.25c.19-.33.285-.495.408-.55a.417.417 0 01.34 0c.124.056.219.22.408.55l1.63 2.836c.07.122.105.183.154.227.044.04.095.069.15.087.064.02.134.02.275.02l3.27-.007c.38 0 .57 0 .68.079.096.07.158.176.17.294.014.135-.081.3-.272.629l-1.64 2.828c-.071.122-.107.183-.12.248a.418.418 0 000 .174c.013.065.049.126.12.247l1.64 2.829c.19.33.286.494.272.628a.417.417 0 01-.17.295c-.11.08-.3.079-.68.078l-3.27-.007c-.14 0-.211 0-.274.02a.417.417 0 00-.151.088c-.05.044-.084.105-.154.227l-1.63 2.835c-.19.33-.284.495-.408.55a.417.417 0 01-.34 0c-.123-.055-.218-.22-.408-.55l-1.63-2.835c-.07-.122-.104-.183-.154-.227a.416.416 0 00-.15-.087c-.063-.02-.134-.02-.274-.02l-3.27.006c-.381 0-.571.001-.681-.078a.417.417 0 01-.17-.295c-.014-.134.082-.299.272-.628l1.641-2.829c.07-.121.106-.182.12-.247a.415.415 0 000-.174c-.014-.065-.05-.126-.12-.248l-1.64-2.828c-.191-.33-.287-.494-.273-.629a.416.416 0 01.17-.294c.11-.08.3-.08.68-.079l3.27.007c.141 0 .212 0 .275-.02a.416.416 0 00.15-.087c.05-.044.085-.105.155-.227l1.63-2.836z"
                stroke={theme["#0D968F"]}
                strokeWidth={1.66667}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
      )
}
  
  export default SvgComponent